<template>
    <div class="webcastsRisk"></div>
</template>

<script>
export default {
    name: 'webcastsRisk',
    props:{
        pondsid:Number,
        companyId: Number,
        greenhouseId: Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            fullDateData: [], // 保存完整的日期时间，用于tooltip显示
            yData:[],
            yDataCo21: [],
            yDataCo22: [],
            yDataCo23: [],
            yAxisMin: null, 
            timerSetChart: null, // 用于存储setChart的定时器
            timerGetData: null, // 用于存储getData的定时器// 用于存储动态的y轴最小值
            visibilityObserver: null,
        }
    },
    methods: {
        computeCo2(item) {
            if (!item) return 0;
            const vals = [];
            if (item.co21 != null && item.co21 !== 0) vals.push(Number(item.co21));
            if (item.co22 != null && item.co22 !== 0) vals.push(Number(item.co22));
            if (item.co23 != null && item.co23 !== 0) vals.push(Number(item.co23));
            if (vals.length > 0) {
                const sum = vals.reduce((a,b) => a + b, 0);
                return Math.round((sum / vals.length) * 100) / 100;
            }
            return item.co2 || 0;
        },
        updateWithDateRange(start, end) {
            // 使用新的 /sensors/history-by-time 接口，支持精确时间
            const params = {
                greenhouseId: this.greenhouseId,
                startDate: start,
                endDate: end,
                pageNum: 1,
                pageSize: 1000
            };
            this.request.get("/api/sensors/history-by-time", {
                params: params
            }).then(res => {
                // 处理返回结果，支持 Result 包装格式
                const list = Array.isArray(res) ? res :
                             (res && Array.isArray(res.data)) ? res.data :
                             (res && Array.isArray(res.records)) ? res.records : [];
                console.log('[chart6] /sensors/history-by-time response list:', list);
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt ? item.createdAt.split('T') : [];
                    const timePart = dateTime[1] || '';
                    return timePart.substring(0, 5); // 只显示时:分
                });
                this.yDataCo21 = sortedList.map(item => parseFloat(item.co21) || 0);
                this.yDataCo22 = sortedList.map(item => parseFloat(item.co22) || 0);
                this.yDataCo23 = sortedList.map(item => parseFloat(item.co23) || 0);
                this.yData = sortedList.map(item => this.computeCo2(item) || 0);
                // fallback: if all three series are zero, use merged yData for visibility
                const combined = [...this.yDataCo21, ...this.yDataCo22, ...this.yDataCo23];
                const hasNonZero = combined.some(v => v && Number(v) !== 0);
                if (!hasNonZero && this.yData && this.yData.length > 0) {
                    this.yDataCo21 = this.yData.slice();
                    this.yDataCo22 = this.yData.slice();
                    this.yDataCo23 = this.yData.slice();
                }
                console.log('[chart6] yDataCo21,22,23:', this.yDataCo21, this.yDataCo22, this.yDataCo23);
                this.updateDynamicYAxis();
                this.setWebcasts();
            }).catch(err => {
                console.error('获取历史数据失败:', err);
            });
        },
        setData() {
            this.request.get("/api/sensors/latest",{
                params: {
                    companyId: this.companyId,
                    greenhouseId: this.greenhouseId
                }
            }).then(res => {
                const list = Array.isArray(res) ? res :
                              (res && Array.isArray(res.data) ? res.data :
                              (res && Array.isArray(res.records) ? res.records : []));
                // 按时间正序排序（最旧的在前，最新的在右）
                const sortedList = [...list].sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
                // 保存完整日期时间用于tooltip
                this.fullDateData = sortedList.map(item => item.createdAt);
                // 横坐标只显示时间
                this.xData = sortedList.map(item => {
                    const dateTime = item.createdAt.split('T');
                    const timePart = dateTime[1] || '';
                    return timePart.substring(0, 5); // 只显示时:分
                });
                this.yData = sortedList.map(item => this.computeCo2(item) || 0);
                this.yDataCo21 = sortedList.map(item => parseFloat(item.co21) || 0);
                this.yDataCo22 = sortedList.map(item => parseFloat(item.co22) || 0);
                this.yDataCo23 = sortedList.map(item => parseFloat(item.co23) || 0);
                // fallback: if three are all zero, use merged yData for visibility
                const combined = [...this.yDataCo21, ...this.yDataCo22, ...this.yDataCo23];
                const hasNonZero = combined.some(v => v && Number(v) !== 0);
                if (!hasNonZero && this.yData && this.yData.length > 0) {
                    this.yDataCo21 = this.yData.slice();
                    this.yDataCo22 = this.yData.slice();
                    this.yDataCo23 = this.yData.slice();
                }
                console.log('[chart6] setData yDataCo21,22,23:', this.yDataCo21, this.yDataCo22, this.yDataCo23);
                this.updateDynamicYAxis();
                this.setWebcasts();
            })
        },
        updateDynamicYAxis() {
            const combined = [...(this.yData || []), ...(this.yDataCo21 || []), ...(this.yDataCo22 || []), ...(this.yDataCo23 || [])];
            if (combined.length > 0) {
                const minVal = Math.min(...combined);
                const padding = Math.min(minVal * 0.1, 50);
                this.yAxisMin = Math.max(0, minVal - padding);
            }
        },
        setWebcasts() {
            const self = this; // 保存this引用
                console.log('[chart6] render xData length:', this.xData ? this.xData.length : 0, 'series lengths:', this.yDataCo21.length, this.yDataCo22.length, this.yDataCo23.length);
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'line'        // 使用直线指示，避免在不可见/单点数据时出现填充阴影
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    formatter: function(params) {
                        let result = '';
                        if (params && params.length > 0) {
                            const index = params[0].dataIndex;
                            const fullDate = self.fullDateData[index];
                            // 格式化完整日期时间
                            if (fullDate) {
                                const dateTime = fullDate.replace('T', ' ');
                                result = dateTime + '<br/>';
                            }
                            params.forEach(param => {
                                result += `${param.seriesName}: ${param.value}ppm<br/>`;
                            });
                        }
                        return result;
                    }
                },
                grid: {
                    top: '12%',
                    bottom: '12%',
                    left: '8%',
                    right: '5%',
                },
                legend: {
                    right: '5%',
                    top: '10%',
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10,
                    },
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 5],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {
                        color: '#122C49',
                        inside: false
                    },
                    z: 2,
                    data: this.xData
                },
                yAxis:
                    {
                        type: 'value',
                        min: this.yAxisMin,
                        max: 1000,
                        // splitNumber: 8,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 10
                        },
                        splitLine: {
                            show: false,
                        },
                        name: '(ppm)',
                        nameGap: 0,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 10, 0, 0]
                        },
                    },

                series: [
                    {
                        name: 'CO₂（0米）',
                        type: 'line',
                        symbol: 'circle',
                        showSymbol: true,
                        symbolSize: 6,
                        data: this.yDataCo21,
                        animation: true,
                        animationDuration: 1200,
                        animationDelay: function (idx) { return idx * 60; },
                        animationEasing: 'cubicOut',
                        lineStyle: { width: 1, color: '#ff8c00' },
                        itemStyle: { color: '#ff8c00' }
                    },
                    {
                        name: 'CO₂（14米）',
                        type: 'line',
                        symbol: 'circle',
                        showSymbol: true,
                        symbolSize: 6,
                        data: this.yDataCo22,
                        animation: true,
                        animationDuration: 1200,
                        animationDelay: function (idx) { return idx * 80; },
                        animationEasing: 'cubicOut',
                        lineStyle: { width: 1, color: '#00bfff' },
                        itemStyle: { color: '#00bfff' }
                    },
                    {
                        name: 'CO₂（28米）',
                        type: 'line',
                        symbol: 'circle',
                        showSymbol: true,
                        symbolSize: 6,
                        data: this.yDataCo23,
                        animation: true,
                        animationDuration: 1200,
                        animationDelay: function (idx) { return idx * 100; },
                        animationEasing: 'cubicOut',
                        lineStyle: { width: 1, color: '#7b68ee' },
                        itemStyle: { color: '#7b68ee' }
                    }
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
            // 确保在容器可见后强制 resize 并触发重绘（防止初始不可见导致空白）
            setTimeout(() => {
                try { this.myChart.resize(); } catch (e) { console.warn('chart6 resize timeout error', e); }
            }, 80);
        },
    },
    mounted() {
        // 移除 mounted 中的 setData，只依赖 watch 触发
        // 监听元素可见性，元素可见后强制刷新图表（解决首次不可见导致不渲染的问题）
        try {
            this.visibilityObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 当元素变为可见，确保图表数据与尺寸正确
                        this.$nextTick(() => {
                            if (this.myChart) {
                                try { this.myChart.resize(); } catch (e) { console.warn('chart6 resize error', e); }
                                this.setWebcasts();
                            }
                        });
                    }
                });
            }, { threshold: 0.1 });
            if (this.$el && this.visibilityObserver) this.visibilityObserver.observe(this.$el);
        } catch (e) {
            console.warn('IntersectionObserver not available, fallback to interval', e);
        }

        // 启动定时器，每2分钟刷新图表，每5分钟获取新数据
        this.timerSetChart = setInterval(() => {
            if (this.myChart) {
                try { this.myChart.resize(); } catch (e) { console.warn('chart6 periodic resize error', e); }
            }
        }, 2 * 60 * 1000); // 2分钟

        // 每五分钟执行一次setData
        this.timerGetData = setInterval(() => {
            // 只有当有有效数据时才刷新
            if (this.greenhouseId) {
                this.setData();
            }
        }, 5 * 60 * 1000); // 5分钟
    },
    watch: {
        // 移除 immediate: true，只在值真正变化时触发
        pondsid() {
            if (this.pondsid) this.setData();
        },
        greenhouseId() {
            if (this.greenhouseId) this.setData();
        },
        companyId() {
            if (this.companyId) this.setData();
        }
    },
    beforeDestroy() {
        // 清除定时器
        clearInterval(this.timerSetChart);
        clearInterval(this.timerGetData);
        if (this.visibilityObserver) {
            try { this.visibilityObserver.disconnect(); } catch (e) { console.warn('visibilityObserver disconnect error', e); }
            this.visibilityObserver = null;
        }
    }
}
</script>

<style lang="less" scoped>
.webcastsRisk {
    
    height: 70%;
}
</style>
